const HIDE_ANIMATION_TIMEOUT = 500 // in milliseconds
const REMOVE_TIMEOUT = 5000 // in milliseconds
const SHOW_ANIMATION_TIMEOUT = 25 // in milliseconds
// Be careful lowering this timeout, too low and develops inconsistency whether sr will read or not
const SCREEN_READER_TIMEOUT = 500

class FlashObject {
  static parse(node) {
    const flash = new FlashObject({})
    flash.body = node
    flash.body.addEventListener("click", () => flash.remove())
    flash.startRemoveTimeout()
    flash.announceToScreenReader(node.textContent)
  }

  constructor(attrs) {
    const options = Object.assign(
      {
        type: "notice",
      },
      attrs,
    )

    this.body = document.createElement("p")
    this.body.classList.add("flash", "fold-to-top", options.type)
    this.body.textContent = options.message
    this.body.setAttribute("aria-hidden", "true")
    this.body.addEventListener("click", () => this.remove())
  }

  show() {
    document.body.appendChild(this.body)

    setTimeout(() => {
      this.body.classList.add("show")
      this.body.classList.remove("fold-to-top")
    }, SHOW_ANIMATION_TIMEOUT)

    this.startRemoveTimeout()
    this.announceToScreenReader(this.body.textContent)
  }

  announceToScreenReader(message) {
    const announcer = document.getElementById("flash-announcer")

    if (announcer && message) {
      announcer.textContent = ""

      setTimeout(() => {
        const currentAnnouncer = document.getElementById("flash-announcer")
        if (currentAnnouncer) {
          currentAnnouncer.textContent = message
        }
      }, SCREEN_READER_TIMEOUT)
    }
  }

  startRemoveTimeout() {
    setTimeout(this.remove.bind(this), REMOVE_TIMEOUT)
  }

  remove() {
    this.body.classList.remove("show")
    this.body.classList.add("fold-to-top")

    setTimeout(() => this.body.remove(), HIDE_ANIMATION_TIMEOUT)
  }
}

class Flash {
  static bindServerFlash() {
    Array.from(document.querySelectorAll("p.flash")).forEach((node) => FlashObject.parse(node))
  }

  static now(type, message) {
    new FlashObject({ type, message }).show()
  }
}

export default Flash
